import { firestore } from '@/firebaseConfig'
import MapObjectStatusTemplate from '@/model/MapObjectStatusTemplate';
import UUIDUtils from '@/utils/UUIDUtils';
import LangUtils from '@/utils/LangUtils';
import StringUtils from '../utils/StringUtils';

export default class MapObjectStatusService {
    constructor(locale) {
        this.locale = locale;
    }

    loadMapObjectStatusTemplates(publisherId, onlyActiveStatus = false) {
        const promise = new Promise((resolve, reject) => {
            var query = firestore.collection("publishers").doc(publisherId).collection("mapObjectStatusTemplates");
            if (onlyActiveStatus) {
                query = query.where("active", "==", true);
            }
            query.get().then((querySnapshot) => {
                const result = [];

                querySnapshot.forEach((doc) => {
                    result.push(new MapObjectStatusTemplate(doc.data()));
                });

                result.sort((a, b) => {
                    const aTitle = LangUtils.valueForLanguage(a.title, this.locale);
                    const bTitle = LangUtils.valueForLanguage(b.title, this.locale);

                    return StringUtils.compare(aTitle, bTitle);
                })

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    saveMapObjectStatusTemplate(publisherId, mapObjectStatusTemplate) {
        const promise = new Promise((resolve, reject) => {
            if (!mapObjectStatusTemplate.id) {
                mapObjectStatusTemplate.id = UUIDUtils.generateUUID();
            }

            if (!mapObjectStatusTemplate.color) {
                mapObjectStatusTemplate.color = "#ffffff";
            }

            firestore.collection("publishers").doc(publisherId).collection("mapObjectStatusTemplates").doc(mapObjectStatusTemplate.id).set(mapObjectStatusTemplate.toJSON()).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    deleteMapObjectStatusTemplate(publisherId, mapObjectStatusTemplateId) {
        return firestore.collection("publishers").doc(publisherId).collection("mapObjectStatusTemplates").doc(mapObjectStatusTemplateId).delete();
    }
}
